import { PerspectiveCamera, Vector3 } from 'three';
export class PositionService {
    init(camera, [x, y, z, lookX, lookY, lookZ]) {
        this.camera = camera;
        this.lookAt = new Vector3(lookX, lookY, lookZ);
        this.position = new Vector3(x, y, z);
        const _distance = this.lookAt.clone().sub(this.position).length();
        this.dir = this.lookAt.clone().sub(this.position).negate().normalize();
    }
    stateFromDistance(distance) {
        const dir = this.dir.clone().multiplyScalar(distance);
        const position = this.lookAt.clone().add(dir);
        return position.toArray().concat(this.lookAt.toArray());
    }
    getCameraAtDistance(distance) {
        const state = this.stateFromDistance(distance);
        return this.cameraFromState(state);
    }
    cameraFromState([x, y, z, lookX, lookY, lookZ]) {
        const t = this.camera;
        const camera = new PerspectiveCamera(t.fov, t.aspect, t.near, t.far);
        camera.position.copy(new Vector3(x, y, z));
        camera.lookAt(new Vector3(lookX, lookY, lookZ));
        camera.updateMatrixWorld();
        return camera;
    }
}
//# sourceMappingURL=PositionService.js.map